import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _styled from "styled-components";
var _path;
var _excluded = ["className", "anchorRef", "position", "setPosition", "isVisible", "triggerRect", "onDismiss", "dismissOnClickOutside", "unmountChildrenOnClose", "style", "isDark", "dark", "children", "arrowProps", "htmlProps"];
import { forwardRef, Fragment, useEffect, useRef } from 'react';
import cn from 'classnames';
import { useMountChildrenValidation } from '@crehana/react-hooks';
import useRect from "../helpers/useRect";
import getPosition from "../Tooltip/helpers/getPosition";
import getStyles from "../Tooltip/helpers/getStyles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var PopperContent = function PopperContent(_ref, forwardedRef) {
  var className = _ref.className,
    anchorRef = _ref.anchorRef,
    position = _ref.position,
    _ref$setPosition = _ref.setPosition,
    setPosition = _ref$setPosition === void 0 ? getPosition : _ref$setPosition,
    isVisible = _ref.isVisible,
    triggerRect = _ref.triggerRect,
    onDismiss = _ref.onDismiss,
    dismissOnClickOutside = _ref.dismissOnClickOutside,
    unmountChildrenOnClose = _ref.unmountChildrenOnClose,
    style = _ref.style,
    isDark = _ref.isDark,
    dark = _ref.dark,
    children = _ref.children,
    arrowProps = _ref.arrowProps,
    htmlProps = _ref.htmlProps,
    popperContentProps = _objectWithoutProperties(_ref, _excluded);
  var ownRef = useRef(null);
  var ref = forwardedRef || ownRef;
  var tooltipRect = useRect(ownRef, isVisible);
  var shouldMountChildren = useMountChildrenValidation({
    isOpen: isVisible,
    unmountChildrenOnClose: unmountChildrenOnClose
  });
  useEffect(function () {
    var listener = function listener(event) {
      if (onDismiss && ref && typeof ref !== 'function' && ref.current && !ref.current.contains(event.target) && (!anchorRef || !anchorRef.current || !anchorRef.current.contains(event.target))) {
        onDismiss();
      }
    };
    if (dismissOnClickOutside) {
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
    } else {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    }
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dismissOnClickOutside, onDismiss]);
  var canShowArrow = arrowProps && arrowProps.visible !== false;
  var calculatedStyles = getStyles(setPosition, triggerRect, tooltipRect);
  var arrowWidth = 19;
  var getArrowStyles = function getArrowStyles() {
    var triggerHalf = triggerRect.width / 2 - arrowWidth / 2;
    // const triggerEnd

    var top = (calculatedStyles.top || 0) + 2;
    var left = calculatedStyles.left || 0;
    if ((arrowProps === null || arrowProps === void 0 ? void 0 : arrowProps.triggerPosition) === 'center') {
      left += triggerHalf;
    } else if ((arrowProps === null || arrowProps === void 0 ? void 0 : arrowProps.triggerPosition) === 'end') {
      left += triggerHalf * 2;
    }
    return _objectSpread(_objectSpread(_objectSpread({}, arrowProps === null || arrowProps === void 0 ? void 0 : arrowProps.style), calculatedStyles), {}, {
      top: top,
      left: left
    });
  };
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [canShowArrow ? /*#__PURE__*/_jsx(_StyledSvg, {
      width: arrowWidth,
      height: "10",
      viewBox: "0 0 19 10",
      xmlns: "http://www.w3.org/2000/svg",
      className: cn('absolute fill-current z-snackbar', isDark || dark ? 'text-base-dark' : 'text-white', arrowProps === null || arrowProps === void 0 ? void 0 : arrowProps.className),
      style: getArrowStyles()
      // @ts-ignore (Property 'css' does not exist on type SVGProps<SVGElement>)
      ,
      $_css: arrowProps === null || arrowProps === void 0 ? void 0 : arrowProps.css,
      children: _path || (_path = /*#__PURE__*/_jsx("path", {
        d: "M19 10H0L7.5898 1.56689C8.35635 0.715171 9.68035 0.680351 10.4906 1.4906L19 10Z"
      }))
    }) : null, /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread(_objectSpread({
      role: "tooltip",
      style: _objectSpread(_objectSpread({}, style), calculatedStyles),
      ref: ref,
      className: cn('shadow-tooltip absolute z-dialog whitespace-no-wrap rounded-5', isDark || dark ? 'bg-base-dark text-white' : 'bg-white text-base-main', canShowArrow ? 'mt-12' : '', className)
    }, popperContentProps), htmlProps), {}, {
      children: shouldMountChildren && children
    }))]
  });
};
export default /*#__PURE__*/forwardRef(PopperContent);
var _StyledSvg = /*#__PURE__*/_styled("svg").withConfig({
  componentId: "sc-l7z6o-0"
})(["", ""], function (p) {
  return p.$_css;
});